import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + "M"
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + "K"
  }
  return num.toString()
}

export function formatCurrency(amount, currency = "IRR") {
  return new Intl.NumberFormat("fa-IR", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount)
}

export function formatDate(date) {
  return new Intl.DateTimeFormat("fa-IR", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(date))
}

export function timeAgo(date) {
  const seconds = Math.floor((Date.now() - new Date(date)) / 1000)
  
  let interval = seconds / 31536000
  if (interval > 1) return Math.floor(interval) + " years ago"
  
  interval = seconds / 2592000
  if (interval > 1) return Math.floor(interval) + " months ago"
  
  interval = seconds / 86400
  if (interval > 1) return Math.floor(interval) + " days ago"
  
  interval = seconds / 3600
  if (interval > 1) return Math.floor(interval) + " hours ago"
  
  interval = seconds / 60
  if (interval > 1) return Math.floor(interval) + " minutes ago"
  
  return "just now"
}

export function getStatusColor(status) {
  const colors = {
    ok: "text-success",
    success: "text-success",
    error: "text-destructive",
    failed: "text-destructive",
    warning: "text-warning",
    pending: "text-muted-foreground",
    processing: "text-info",
    offline: "text-muted-foreground",
  }
  return colors[status] || "text-muted-foreground"
}

export function truncate(str, length = 50) {
  if (!str) return ""
  if (str.length <= length) return str
  return str.slice(0, length) + "..."
}

export function copyToClipboard(text) {
  navigator.clipboard.writeText(text)
}

export function generateId() {
  return Math.random().toString(36).substring(2, 15)
}
